import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./app/utils/ResizeObserverFix";
import ReactDOM from "react-dom";
import store, { persistor } from "./app/store/store";
import axios from "axios";
import { setupAxios } from "./app/utils/AuthUtils";
import App from "./App";
import "./index.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "@fontsource/lato";
import "@fontsource/lato/300-italic.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const { PUBLIC_URL } = process.env;

// Interceptador do axios para verificar
// se possui token e configurar header.
setupAxios(axios, store);

ReactDOM.render(
	<App store={store} persistor={persistor} basename={PUBLIC_URL} />,
	document.getElementById("root")
);

serviceWorkerRegistration.register();
